// Scene.js
export function createScene() {
  const items = [];
  const hoverTargets = [];
  const overlaysById = new Map();

  return {
    // 렌더만
    add(item) {
      items.push(item);
      return item;
    },

    // 렌더 + hover
    addHoverTarget(item) {
      items.push(item);
      hoverTargets.push(item);
      return item;
    },

    // 페이드인/아웃 이미지 등록
    addHoverOverlay(id, item) {
      item.alpha = 0;
      item.targetAlpha = 0;
      item.visible = false;
      items.push(item);
      overlaysById.set(id, item);
      return item;
    },

    // 페이드인/아웃 토글
    setOverlay(id, on) {
      const overlay = overlaysById.get(id);
      if (!overlay) return;
      overlay.targetAlpha = on ? 1 : 0;
      overlay.visible = true;
    },

    draw(ctx, sceneAlpha = 1) {
      for (const item of items) {
        if (!item.draw) continue;
        item.draw(ctx, sceneAlpha);
      }
    },
    update(dt) {
      let changed = false;
      for (const item of items) {
        if (item.update) changed = item.update(dt) || changed;
      }
      return changed;
    },
    items,
    hoverTargets,
  };
}
